
import {Component, Prop, Vue} from "vue-property-decorator";
import DataFieldCache from "../../../models/data.field.cache";
import dataFieldTypes from "@/dataFieldTypes";
import {dataFieldsEditModule, studyDefinitionModule} from "@/store";
import {translate} from "@/auxillary/translation";
import Hints from "@/components/study/datafields/base/Hints.vue";
import {compareMedicalDateFields} from "@/auxillary/dateComparer";
import {resolveConstraintExpression} from "@/auxillary/constraint.expression.resolver";
import {MdbsCore} from "@/api/tsclient";
import DataFieldDefinitionDto = MdbsCore.DataFieldDefinitionDto;
import {findField} from "@/auxillary/datafield.cache.helpers";

@Component({
  name: 'ListField',
  components: {
    ...dataFieldTypes, Hints
  },
})
export default class ListField extends Vue {

  @Prop({required: true})
  private dataField: DataFieldCache

  hiddenHintShown: boolean = false;

  public panels: Array<number> = [];

  get field() {
    return this.dataField;
  }

  get isVisible() {
    return this.dataField.isVisible ?? false;
  }

  get validationMessages() {
    return this.dataField?.id != null
        ? dataFieldsEditModule.validationMessages.filter(m => m.dataFieldId == this.dataField.id)
        : [];
  }

  translateMessage(displayKey: string, parameters?: { [key: string]: string }) {
    const translation = translate(displayKey, undefined, parameters);
    return translation != displayKey
        ? translation
        : "Dies ist eine Pflichtangabe. Bitte fügen Sie mindestens einen Eintrag hinzu.";  // TODO hacky way to have required field messages
  }

  get isEditable() {
    return this.dataField.isEditable;
  }

  get displayName() {
    return this.dataField?.displayName;
  }

  get childFields() {
    if (this.dataField.definition.sorting != undefined)
      return this.sortedChildFields;
    return this.dataField?.childFields ?? [];
  }

  get sortedChildFields() {
    const sortingFieldIdentifier = this.dataField.definition.sorting?.field;
    const sortingOrder = this.dataField.definition.sorting?.order ?? 'asc';
    const sortingType = this.dataField.definition.sorting?.type ?? 'date';

    if (sortingFieldIdentifier == undefined || sortingType != "date")
      return this.dataField?.childFields ?? [];

    return this.dataField?.childFields.sort((field1, field2) => {
      if (field1.isNewField || field2.isNewField)
        return 0;
      const listEntryField1 = field1.childFields.find(d => d.identifier == sortingFieldIdentifier)
      const listEntryField2 = field2.childFields.find(d => d.identifier == sortingFieldIdentifier)
      return compareMedicalDateFields(listEntryField1?.values, listEntryField2?.values, sortingOrder);
    });
  }

  get childFieldDefinitions(): DataFieldDefinitionDto[] {
    const field = findField(this.dataField, dataFieldsEditModule.dataFields)
    if (!field?.referenceId) return [];

    let referenceDefinition;
    if (field.referenceType == "PatientDefinition")
      referenceDefinition = studyDefinitionModule.patientDefinition;
    else if (field.referenceType == "VisitDefinition")
      referenceDefinition = studyDefinitionModule.visitDefinitionById(field.referenceId)
    else
      referenceDefinition = studyDefinitionModule.instrumentDefinitionById(field.referenceId)

    const childFieldDefintions = referenceDefinition?.fields
        ?.filter(f => !f.isDeleted && f.parentFieldDefinitionId == field.definitionId) ?? [];

    return childFieldDefintions;
  }

  get visibleChildFieldDefinitions() {
    const visibleChildDefinitions = [];
    for (const childFieldDefinition of this.childFieldDefinitions) {
      // Only an explicit false blocks creation; a missing property keeps the previous behaviour.
      if (childFieldDefinition.definition?.create === false) continue;

      const maxCount = childFieldDefinition.definition?.max;
      if (maxCount != undefined) {
        const childCount = (this.childFields.filter(c => {
          return !c.isDeleted && c.definitionId == childFieldDefinition.id
        }) ?? []).length;
        if (childCount >= maxCount) continue;
      }

      const visibilityRules = childFieldDefinition.rules?.filter(r => r.definitionType == "Visibility" && !r.isDeleted) ?? [];
      if (visibilityRules.length > 0 &&
          visibilityRules.some(r => !resolveConstraintExpression(r.constraintExpression))) continue;

      visibleChildDefinitions.push(childFieldDefinition)
    }

    return visibleChildDefinitions;
  }

  createNewListEntry(childFieldDefinitionId: string | undefined) {
    // workaround to access store getters in mutations: https://github.com/vuejs/vuex/issues/684
    dataFieldsEditModule.createChildField({
      parentField: this.dataField,
      temporaryFields: dataFieldsEditModule.temporaryFields,
      childFieldDefinitionId: childFieldDefinitionId ?? this.visibleChildFieldDefinitions[0].id
    })
    this.panels.push(this.childFields.length - 1)
  }

  updateHiddenHintShown(event: any) {
    this.hiddenHintShown = event;
  }

}
